// Search boxes that ask the server: the value settles for `ms` before it is used, so typing
// "saree" sends one request instead of five (fewer round trips on slow mobile data).
import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setV(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return v;
}
